<section class="adoption-page">

  <header class="page-header">
    <div class="page-header-text">
      <h1 class="page-title">Adoption &amp; Engagement</h1>
      <p class="page-sub">Whether users are returning to EDC and consuming the reports and features that support daily work.</p>
    </div>
    <div class="filterbar">
      <span class="filter active">Latest Export</span>
      <span class="filter">All NAMCs</span>
      <span class="filter">All Shops</span>
    </div>
  </header>

  <nav class="program-tabs" role="tablist" aria-label="Adoption &amp; Engagement sub pages">
    <button type="button" class="program-tab" [class.active]="activeProgramPage === 'adoptionOverview'"
      (click)="selectProgramPage('adoptionOverview')" role="tab" [attr.aria-selected]="activeProgramPage === 'adoptionOverview'">
      Adoption Overview
    </button>
    <button type="button" class="program-tab" [class.active]="activeProgramPage === 'utilizationOverview'"
      (click)="selectProgramPage('utilizationOverview')" role="tab" [attr.aria-selected]="activeProgramPage === 'utilizationOverview'">
      Utilization Overview
    </button>
    <button type="button" class="program-tab" [class.active]="activeProgramPage === 'trainingCompletion'"
      (click)="selectProgramPage('trainingCompletion')" role="tab" [attr.aria-selected]="activeProgramPage === 'trainingCompletion'">
      Training Completion
    </button>
  </nav>

  <div *ngIf="activeProgramPage === 'adoptionOverview'" role="tabpanel" class="program-tab-content">

  <!-- KPI Cards -->
  <div class="kpi-grid">
    <article class="kpi-card">
      <span class="kpi-label">Adoption Rate</span>
      <div class="kpi-value">82%</div>
      <div class="kpi-delta kpi-delta--up">▲ 2.8%</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">Daily Active Users</span>
      <div class="kpi-value">1,245</div>
      <div class="kpi-delta kpi-delta--up">▲ 84</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">Weekly Active Users</span>
      <div class="kpi-value">3,872</div>
      <div class="kpi-delta kpi-delta--up">▲ 6.4%</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">Report Views</span>
      <div class="kpi-value">67,149</div>
      <div class="kpi-delta">Across 27 active reports</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">Most Consumed Report</span>
      <div class="kpi-value kpi-value--sm">2411 Equip Summary</div>
      <div class="kpi-delta">35,037 views</div>
    </article>
    <article class="kpi-card">
      <span class="kpi-label">Returning Users</span>
      <div class="kpi-value">66%</div>
      <div class="kpi-delta kpi-delta--up">▲ 3.1%</div>
    </article>
  </div>

  <!-- Trend chart + NAMC Accordion -->
  <div class="content-grid two-col">

    <article class="panel chart-panel">
      <div class="panel-head">
        <div class="panel-head-text">
          <h3 class="section-title">Adoption Trend by Plant</h3>
          <p class="muted">Compare NAMCs, isolate one plant, or compare the same shop type across plants.</p>
        </div>
        <div class="filter-pair">
          <label class="select-control">
            Plant / NAMC
            <select aria-label="Select plant or NAMC">
              <option value="ALL">Compare All NAMCs</option>
              <option value="TMMI">TMMI</option>
              <option value="TABC">TABC</option>
              <option value="TMMTX">TMMTX</option>
              <option value="TMMK">TMMK</option>
              <option value="TMMMS">TMMMS</option>
              <option value="TMMC">TMMC</option>
            </select>
          </label>
          <label class="select-control">
            Shop Type
            <select aria-label="Select shop type">
              <option value="ALL">All Shop Types</option>
              <option value="Assembly">Assembly</option>
              <option value="Body Weld">Body Weld</option>
              <option value="Paint">Paint</option>
              <option value="Plastics">Plastics</option>
              <option value="Stamping">Stamping</option>
              <option value="Casting">Casting</option>
              <option value="Other">Other</option>
            </select>
          </label>
        </div>
      </div>
      <div class="chart-area">
        <svg viewBox="0 0 620 220" aria-label="Adoption trend chart placeholder">
          <!-- Grid lines -->
          <line class="chart-grid" x1="38" y1="18" x2="606" y2="18"/>
          <line class="chart-grid" x1="38" y1="55" x2="606" y2="55"/>
          <line class="chart-grid" x1="38" y1="91" x2="606" y2="91"/>
          <line class="chart-grid" x1="38" y1="128" x2="606" y2="128"/>
          <line class="chart-grid" x1="38" y1="164" x2="606" y2="164"/>
          <line class="chart-grid" x1="38" y1="200" x2="606" y2="200"/>
          <!-- Y-axis labels -->
          <text class="chart-label" x="32" y="21" text-anchor="end">100%</text>
          <text class="chart-label" x="32" y="58" text-anchor="end">90%</text>
          <text class="chart-label" x="32" y="94" text-anchor="end">80%</text>
          <text class="chart-label" x="32" y="131" text-anchor="end">70%</text>
          <text class="chart-label" x="32" y="167" text-anchor="end">60%</text>
          <!-- X-axis labels -->
          <text class="chart-label" x="38" y="214" text-anchor="middle">W1</text>
          <text class="chart-label" x="188" y="214" text-anchor="middle">W4</text>
          <text class="chart-label" x="382" y="214" text-anchor="middle">W8</text>
          <text class="chart-label" x="606" y="214" text-anchor="middle">W12</text>
          <!-- TMMI trend line -->
          <polyline class="trend-line" stroke="#6f42c1"
            points="38,128 88,121 138,115 188,108 238,101 288,101 338,94 388,87 438,87 488,80 538,73 606,73"/>
          <!-- TABC trend line -->
          <polyline class="trend-line" stroke="#0070c0"
            points="38,55 88,48 138,48 188,41 238,34 288,27 338,27 388,20 438,14 488,14 538,7 606,7"/>
          <!-- TMMTX trend line -->
          <polyline class="trend-line" stroke="#ef7d00"
            points="38,155 88,148 138,141 188,135 238,128 288,121 338,115 388,108 438,101 488,95 538,95 606,88"/>
        </svg>
      </div>
      <div class="chart-legend">
        <span class="legend-item"><i class="legend-swatch" style="background:#6f42c1"></i> TMMI 79%</span>
        <span class="legend-item"><i class="legend-swatch" style="background:#0070c0"></i> TABC 92%</span>
        <span class="legend-item"><i class="legend-swatch" style="background:#ef7d00"></i> TMMTX 73%</span>
        <span class="legend-item"><i class="legend-swatch" style="background:#1b9e77"></i> TMMK 81%</span>
        <span class="legend-item"><i class="legend-swatch" style="background:#d45087"></i> TMMMS 75%</span>
        <span class="legend-item"><i class="legend-swatch" style="background:#5c6f82"></i> TMMC 86%</span>
      </div>
    </article>

    <article class="panel">
      <h3 class="section-title">Adoption by NAMC</h3>
      <p class="muted" style="margin-bottom: 10px">Expand a NAMC to review the adoption rate of its shops.</p>
      <div class="adoption-accordion">

        <details class="adoption-group">
          <summary>
            <strong>TABC</strong>
            <div class="bar-bg"><div class="bar bar--purple" style="width: 92%"></div></div>
            <b>92%</b>
            <span class="chevron" aria-hidden="true">›</span>
          </summary>
          <div class="shop-adoption-list">
            <div class="shop-adoption-row">
              <span>Body Weld</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 94%"></div></div>
              <b>94%</b>
            </div>
            <div class="shop-adoption-row">
              <span>Stamping</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 93%"></div></div>
              <b>93%</b>
            </div>
            <div class="shop-adoption-row">
              <span>Tool &amp; Die</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 89%"></div></div>
              <b>89%</b>
            </div>
          </div>
        </details>

        <details class="adoption-group">
          <summary>
            <strong>TMMC</strong>
            <div class="bar-bg"><div class="bar bar--purple" style="width: 86%"></div></div>
            <b>86%</b>
            <span class="chevron" aria-hidden="true">›</span>
          </summary>
          <div class="shop-adoption-list">
            <div class="shop-adoption-row">
              <span>North Assembly</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 89%"></div></div>
              <b>89%</b>
            </div>
            <div class="shop-adoption-row">
              <span>South Assembly</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 87%"></div></div>
              <b>87%</b>
            </div>
            <div class="shop-adoption-row">
              <span>Body Weld</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 84%"></div></div>
              <b>84%</b>
            </div>
            <div class="shop-adoption-row">
              <span>Paint</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 83%"></div></div>
              <b>83%</b>
            </div>
          </div>
        </details>

        <details class="adoption-group">
          <summary>
            <strong>TMMI</strong>
            <div class="bar-bg"><div class="bar bar--purple" style="width: 79%"></div></div>
            <b>79%</b>
            <span class="chevron" aria-hidden="true">›</span>
          </summary>
          <div class="shop-adoption-list">
            <div class="shop-adoption-row">
              <span>East Assembly</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 84%"></div></div>
              <b>84%</b>
            </div>
            <div class="shop-adoption-row">
              <span>Plastics</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 82%"></div></div>
              <b>82%</b>
            </div>
            <div class="shop-adoption-row">
              <span>West Assembly</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 80%"></div></div>
              <b>80%</b>
            </div>
            <div class="shop-adoption-row">
              <span>East Body Weld</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 79%"></div></div>
              <b>79%</b>
            </div>
            <div class="shop-adoption-row">
              <span>West Body Weld</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 76%"></div></div>
              <b>76%</b>
            </div>
            <div class="shop-adoption-row">
              <span>Stamping</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 75%"></div></div>
              <b>75%</b>
            </div>
            <div class="shop-adoption-row">
              <span>East Paint</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 73%"></div></div>
              <b>73%</b>
            </div>
            <div class="shop-adoption-row">
              <span>West Paint</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 70%"></div></div>
              <b>70%</b>
            </div>
          </div>
        </details>

        <details class="adoption-group">
          <summary>
            <strong>TMMK</strong>
            <div class="bar-bg"><div class="bar bar--purple" style="width: 81%"></div></div>
            <b>81%</b>
            <span class="chevron" aria-hidden="true">›</span>
          </summary>
          <div class="shop-adoption-list">
            <div class="shop-adoption-row">
              <span>Assembly</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 85%"></div></div>
              <b>85%</b>
            </div>
            <div class="shop-adoption-row">
              <span>Body Weld</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 82%"></div></div>
              <b>82%</b>
            </div>
            <div class="shop-adoption-row">
              <span>Paint</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 80%"></div></div>
              <b>80%</b>
            </div>
            <div class="shop-adoption-row">
              <span>Stamping</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 78%"></div></div>
              <b>78%</b>
            </div>
          </div>
        </details>

        <details class="adoption-group">
          <summary>
            <strong>TMMMS</strong>
            <div class="bar-bg"><div class="bar bar--purple" style="width: 75%"></div></div>
            <b>75%</b>
            <span class="chevron" aria-hidden="true">›</span>
          </summary>
          <div class="shop-adoption-list">
            <div class="shop-adoption-row">
              <span>Assembly</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 78%"></div></div>
              <b>78%</b>
            </div>
            <div class="shop-adoption-row">
              <span>Body Weld</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 75%"></div></div>
              <b>75%</b>
            </div>
            <div class="shop-adoption-row">
              <span>Paint</span>
              <div class="bar-bg"><div class="bar bar--purple" style="width: 72%"></div></div>
              <b>72%</b>
            </div>
          </div>
        </details>

      </div>
      <p class="adoption-note">Values are illustrative placeholders until shop-level adoption data is connected.</p>
    </article>

  </div>

  <!-- Report Consumption -->
  <article class="panel module-gap">
    <div class="section-head-row">
      <div>
        <h3 class="section-title">Report Consumption</h3>
        <p class="muted">Shows which reports users are consuming. Filter by NAMC and shop type to identify high-value reports, adoption gaps, and training opportunities.</p>
      </div>
      <div class="filter-pair">
        <label class="select-control">
          NAMC
          <select aria-label="Select NAMC">
            <option value="ALL">All NAMCs</option>
            <option value="TMMI">TMMI</option>
            <option value="TABC">TABC</option>
            <option value="TMMTX">TMMTX</option>
            <option value="TMMK">TMMK</option>
            <option value="TMMMS">TMMMS</option>
            <option value="TMMC">TMMC</option>
          </select>
        </label>
        <label class="select-control">
          Shop Type
          <select aria-label="Select shop type">
            <option value="ALL">All Shop Types</option>
            <option value="Assembly">Assembly</option>
            <option value="Body Weld">Body Weld</option>
            <option value="Paint">Paint</option>
            <option value="Plastics">Plastics</option>
            <option value="Stamping">Stamping</option>
            <option value="Casting">Casting</option>
            <option value="Other">Other</option>
          </select>
        </label>
      </div>
    </div>

    <div class="consumption-chart-box">
      <h4 class="section-title-sm">Top Report Consumption</h4>
      <p class="muted" style="margin-bottom: 12px">Top five reports for the selected NAMC and shop type.</p>
      <div class="consumption-bars">
        <div class="value-bar-row">
          <div class="value-bar-label"><span>2411 Equip Summary KPI</span><b>35,037</b></div>
          <div class="value-bar-track"><div class="value-bar-fill" style="width: 100%"></div></div>
        </div>
        <div class="value-bar-row">
          <div class="value-bar-label"><span>2208 Tool Dashboard Sub Report</span><b>23,906</b></div>
          <div class="value-bar-track"><div class="value-bar-fill" style="width: 68%"></div></div>
        </div>
        <div class="value-bar-row">
          <div class="value-bar-label"><span>2208 Tool Dashboard Listing Page</span><b>2,713</b></div>
          <div class="value-bar-track"><div class="value-bar-fill" style="width: 8%"></div></div>
        </div>
        <div class="value-bar-row">
          <div class="value-bar-label"><span>2812 Maximo Sent</span><b>1,633</b></div>
          <div class="value-bar-track"><div class="value-bar-fill" style="width: 5%"></div></div>
        </div>
        <div class="value-bar-row">
          <div class="value-bar-label"><span>2414 Line Trend KPI</span><b>1,301</b></div>
          <div class="value-bar-track"><div class="value-bar-fill" style="width: 4%"></div></div>
        </div>
      </div>
    </div>

    <div class="consumption-insights">

      <div class="insight-card">
        <h4 class="section-title-sm">Top 5 Report Leaderboard</h4>
        <p class="muted">Highest-consumed reports for the current filters.</p>
        <div class="leaderboard-list">
          <div class="leader-row">
            <div class="rank-medal">1</div>
            <div class="row-main"><b title="2411 Equip Summary KPI">2411 Equip Summary KPI</b><span>52.2% of consumption</span></div>
            <div class="row-value">35,037</div>
          </div>
          <div class="leader-row">
            <div class="rank-medal">2</div>
            <div class="row-main"><b title="2208 Tool Dashboard Sub Report">2208 Tool Dashboard Sub Report</b><span>35.6% of consumption</span></div>
            <div class="row-value">23,906</div>
          </div>
          <div class="leader-row">
            <div class="rank-medal">3</div>
            <div class="row-main"><b title="2208 Tool Dashboard Listing Page">2208 Tool Dashboard Listing Page</b><span>4.0% of consumption</span></div>
            <div class="row-value">2,713</div>
          </div>
          <div class="leader-row">
            <div class="rank-medal">4</div>
            <div class="row-main"><b title="2812 Maximo Sent">2812 Maximo Sent</b><span>2.4% of consumption</span></div>
            <div class="row-value">1,633</div>
          </div>
          <div class="leader-row">
            <div class="rank-medal">5</div>
            <div class="row-main"><b title="2414 Line Trend KPI">2414 Line Trend KPI</b><span>1.9% of consumption</span></div>
            <div class="row-value">1,301</div>
          </div>
        </div>
      </div>

      <div class="insight-card">
        <h4 class="section-title-sm">Least Used Reports</h4>
        <p class="muted">Reports with the lowest recorded usage.</p>
        <div class="least-used-list">
          <div class="least-row">
            <div class="row-main"><b>2412 Line Summary KPI</b><span>Low consumption</span></div>
            <div class="row-value">182</div>
          </div>
          <div class="least-row">
            <div class="row-main"><b>2117 Fault Report by Downtime</b><span>Low consumption</span></div>
            <div class="row-value">135</div>
          </div>
          <div class="least-row">
            <div class="row-main"><b>2204 Tool Report By Time</b><span>Low consumption</span></div>
            <div class="row-value">363</div>
          </div>
          <div class="least-row">
            <div class="row-main"><b>2111 Fault Report</b><span>Low consumption</span></div>
            <div class="row-value">359</div>
          </div>
        </div>
      </div>

      <div class="insight-card">
        <h4 class="section-title-sm">Shops with Low Adoption</h4>
        <p class="muted">Shops with the lowest adoption rates — highest training and engagement opportunity.</p>
        <div class="inactive-shop-list">
          <div class="inactive-row">
            <div class="row-main"><b>West Paint</b><span>TMMI · Below 65% threshold</span></div>
            <div class="row-value row-value--bad">70%</div>
          </div>
          <div class="inactive-row">
            <div class="row-main"><b>East Paint</b><span>TMMI · Lowest adoption</span></div>
            <div class="row-value row-value--bad">73%</div>
          </div>
          <div class="inactive-row">
            <div class="row-main"><b>Stamping</b><span>TMMI · Lowest adoption</span></div>
            <div class="row-value row-value--bad">75%</div>
          </div>
          <div class="inactive-row">
            <div class="row-main"><b>Assembly</b><span>TMMTX · Lowest adoption</span></div>
            <div class="row-value row-value--bad">76%</div>
          </div>
          <div class="inactive-row">
            <div class="row-main"><b>Paint</b><span>TMMMS · Lowest adoption</span></div>
            <div class="row-value row-value--bad">72%</div>
          </div>
        </div>
      </div>

    </div>
  </article>

  </div><!-- end adoptionOverview tabpanel -->

  <div *ngIf="activeProgramPage === 'utilizationOverview'" role="tabpanel" class="program-tab-content">
    <app-reporting-utilization></app-reporting-utilization>
  </div>

  <div *ngIf="activeProgramPage === 'trainingCompletion'" role="tabpanel" class="program-tab-content">
    <div class="placeholder-panel">
      <div class="placeholder-icon">
        <i class="pi pi-graduation-cap"></i>
      </div>
      <h2 class="placeholder-title">Training Completion</h2>
      <p class="placeholder-sub">This page is coming soon. We're working on defining the metrics and data sources that will power training completion tracking across all NAMCs and shops.</p>
      <p class="placeholder-note">Check back for updates as this capability is developed.</p>
    </div>
  </div>

</section>
